module.exports = __webpack_public_path__ + "media/images/secondary_early_careers/stem_community-7c6ff2172e6cb8f0effe2604d446f47a.jpg";